import { isFeatureEnabled } from '@lumapps/features';
import { isInstanceSuperAdmin, isUserAllowed, permissionsSelector } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';

import { PLATFORM_SEGMENTS_FEATURE_TOKEN } from '../../constants';
import { SEGMENT_PERMISSIONS } from '../../permissions';

export const isUserAdmin = isUserAllowed();

export const isSegmentEditionAllowed = isUserAllowed(SEGMENT_PERMISSIONS.SEGMENT_EDIT);
export const isSegmentArchiveAllowed = isUserAllowed(SEGMENT_PERMISSIONS.SEGMENT_ARCHIVE);

/** Can access segment admin */
export const canAccessSegmentAdmin = createSelector(
    permissionsSelector,
    isInstanceSuperAdmin,
    (permissions, isInstanceSuperAdmin) =>
        // Is ask ai feature enabled AND a configuration created for the user?
        permissions.authorizations.canCreateSegment ||
        permissions.authorizations.canArchiveSegment ||
        permissions.isSuperAdmin ||
        isInstanceSuperAdmin,
);

/** Can create or edit segments */
export const canAccessSegmentCreateOrEdit = createSelector(
    permissionsSelector,
    isInstanceSuperAdmin,
    (permissions, isInstanceSuperAdmin) =>
        // Is ask ai feature enabled AND a configuration created for the user?
        permissions.authorizations.canCreateSegment || permissions.isSuperAdmin || isInstanceSuperAdmin,
);

/** Can archive segments */
export const canAccessSegmentArchive = createSelector(
    permissionsSelector,

    isInstanceSuperAdmin,
    (permissions, isInstanceSuperAdmin) =>
        // Is ask ai feature enabled AND a configuration created for the user?
        permissions.authorizations.canArchiveSegment || permissions.isSuperAdmin || isInstanceSuperAdmin,
);

/** is platform segments feature flag enabled or not */
export const isPlatformSegmentEnabled = isFeatureEnabled(PLATFORM_SEGMENTS_FEATURE_TOKEN);
